export const GET_BROADCASTGIFT = "GET_BROADCASTGIFT";
export const CREATE_NEW_BROADCASTGIFT = "CREATE_NEW_BROADCASTGIFT";
export const EDIT_BROADCASTGIFT = "EDIT_BROADCASTGIFT";
export const DELETE_BROADCASTGIFT = "DELETE_BROADCASTGIFT";
export const CLOSE_BROADCASTGIFT_DIALOG = "CLOSE_BROADCASTGIFT_DIALOG";
export const OPEN_BROADCASTGIFT_DIALOG = "OPEN_BROADCASTGIFT_DIALOG";
export const VIP_SWITCH_BROADCASTGIFT = "VIP_SWITCH_BROADCASTGIFT";
